import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { type ClassificationRequestData, type ClassificationResultData } from '../../types'
import { classificationApi } from '../api/classificationApi'

export interface ClassificationState {
  queryRequest: ClassificationRequestData | null
  queryResult: ClassificationResultData | null
}

const initialState: ClassificationState = {
  queryRequest: null,
  queryResult: null
}

export const classificationSlice = createSlice({
  name: 'classification',
  initialState,
  reducers: {
    setQueryRequest: (state, action: PayloadAction<ClassificationRequestData>) => {
      state.queryRequest = action.payload
    },
    setClassificationResult: (state, action: PayloadAction<ClassificationResultData>) => {
      state.queryResult = action.payload
    },
    clearClassificationResult: (state) => {
      state.queryResult = null
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      classificationApi.endpoints.getClassificationResult.matchFulfilled,
      (state, { payload }) => {
        state.queryResult = payload
      }
    )
  }
})

// Action creators are generated for each case reducer function
export const { setQueryRequest, setClassificationResult, clearClassificationResult } = classificationSlice.actions

export default classificationSlice.reducer
